import { useCallback } from 'react'

import axios from 'axios'

const useClickLogger = (_click, url) => {
  const clickLogger = (e, _click) => {
    const formData = new FormData();
    // Send data to the backend via POST
    const test = axios.post('/searcher/send_click_response', {
      click: _click,
    })
      .catch((error) => {
        console.log(error);
      });
  }

  const trackResultClick = useCallback((e) => {
    if (_click) clickLogger(e, _click);
    if (e.detail > 0) {
      window.location.assign(url);
    }
  }, [clickLogger, _click]);

  return { trackResultClick }
}

export default useClickLogger;
